import { render } from "./IconPerson.vue?vue&type=template&id=b7ed219e"
import script from "./IconPerson.vue?vue&type=script&lang=ts"
export * from "./IconPerson.vue?vue&type=script&lang=ts"
script.render = render

export default script